import { request } from "../apiService";

export type FundingStatusItem = {
    id: string;
    userId: string;
    isFunded: boolean;
    fundedAccountsCount: number;
    fundedTotalBalance: string;
    asOfDate: string;
    createdAt: string;
};

export type FundingStatusListResponse = {
    items: FundingStatusItem[];
    count: number;
};

export type FundingStatusCreatePayload = {
    isFunded: boolean;
    fundedAccountsCount: number;
    fundedTotalBalance: number;
    asOfDate?: string;
};

export type FundingStatusReminderResponse = {
    needsUpdate: boolean;
    lastUpdateAt: string | null;
};

export const getFundingStatusHistory = async (
    userId: string,
    params?: {
        limit?: number;
        offset?: number;
        sort?: "asOfDate:desc" | "asOfDate:asc";
    }
) => {
    return await request<FundingStatusListResponse, typeof params>(
        `/users/${userId}/funding-status`,
        {
            input: params,
        }
    );
};

export const createFundingStatus = async (
    userId: string,
    payload: FundingStatusCreatePayload
) => {
    return await request<FundingStatusItem, FundingStatusCreatePayload>(
        `/users/${userId}/funding-status`,
        {
            method: "POST",
            input: payload,
        }
    );
};

export const getFundingStatusReminder = async (userId: string) => {
    return await request<FundingStatusReminderResponse>(
        `/users/${userId}/funding-status/reminder`
    );
};

export const deleteFundingStatus = async (userId: string, snapshotId: string) => {
    return await request<void>(`/users/${userId}/funding-status/${snapshotId}`, {
        method: "DELETE",
    });
};
